import { render, staticRenderFns } from "./InvScLPrice_List_Icon.vue?vue&type=template&id=e8a52e18"
import script from "./InvScLPrice_List_Icon.vue?vue&type=script&lang=js"
export * from "./InvScLPrice_List_Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports